import React, { Component } from "react";
import { withStyles } from "@material-ui/core/styles";
import { Modal, Button, Form, Container, Row, Col } from "react-bootstrap";
import SimpleReactValidator from "simple-react-validator";
import { RequestService } from "../../../../service/manage/registration/request_form.service";
import { sweetStatusAlert } from "../../../../components/common/SweetAlert";
import { routes } from "../../../../helper/routes";
import "./ParentStudentLandingPage.css";
import Footer from "../../../../components/admin/layouts/Footer";

const styles = (theme) => ({
  button: {
    margin: theme.spacing(1),
    backgroundColor: "#5458AF",
    color: "white",
  },
});

class ParentStudentLandingPage extends Component {
  constructor(props) {
    super(props);
    this.state = {
      openDialog: false,
      email: "",
      registration_type: null,
      isLoading: false,
    };

    this.validator = new SimpleReactValidator();
  }

  handleRoleSelect = (role) => {
    sessionStorage.setItem("user_role_selection", role);
    this.props.history.push(routes.auth_response);
  };

  handleSignUp = (userType) => {
    this.setState({ registration_type: userType, openDialog: true });
  };

  handleCloseDialog = () => {
    this.validator.hideMessages();
    this.forceUpdate();
    this.setState({ registration_type: null, openDialog: false, email: "" });
  };

  handleEmailChange = (e) => {
    this.setState({ email: e.target.value });
  };

  handleSubmit = () => {
    const { registration_type, email } = this.state;

    if (!this.validator.allValid()) {
      this.validator.showMessages();
      this.forceUpdate();
    } else {
      this.setState({ isLoading: true });

      RequestService.checkEmail(email, registration_type)
        .then((response) => {
          if (response.data) {
            if (response.data.code === 1) {
              this.setState({ email: "", isLoading: false, openDialog: false });
              sweetStatusAlert(
                `${response.data.title && typeof response.data.title === "string" 
                  ? response.data.title 
                  : "Email exist"}`,
                `${typeof response.data.message === "string" 
                  ? response.data.message 
                  : "Email already exist in system"}`,
                "info"
              );
            } else {
              const data = {
                email: email,
                registration_type: registration_type,
              };

              this.setState({ isLoading: false, openDialog: false });

              this.props.history.push({
                pathname: routes.registration_form_view,
                info: {
                  success: true,
                  data: data,
                },
              });
            }
          }
        })
        .catch((error) => {
          console.error("Error checking email:", error);
          this.setState({ isLoading: false });
        });
    }
  };

  render() {
    const { classes } = this.props;
    const { isLoading } = this.state;

    return (
      <div className="landing-page-wrapper">
        <Container fluid className="landing-container">
          <Row className="justify-content-center">
            <Col xs={12} className="text-center" style={{ display: "flex", justifyContent: "center" }}>
              <div className="logo-section">
                <img
                  src="https://landingpage4edsdev.blob.core.windows.net/images/edsiderlogo.png"
                  alt="Edsider Logo"
                  className="logo-img"
                />
              </div>
            </Col>
          </Row>

          <Row className="justify-content-center">
            <Col xs={12} className="text-center">
              <div className="welcome-section">
                <h1 className="welcome-title">Welcome!</h1>
                <p className="welcome-subtitle">
                  Sign Up to continue to your account
                </p>
                <div className="gradient-line"></div>
              </div>
            </Col>
          </Row>

          <Row className="justify-content-center main-content-row">
            {/* Parent Section */}
            <Col xs={12} md={6} lg={5} className="signup-col" style={{ display: "flex", justifyContent: "center" }}>
              <div className="content-card">
                <div className="login-illustration">
                  <div className="parent-img"></div>
                </div>
                
                <div className="button-section">
                  <button
                    onClick={() => this.handleSignUp("parent")}
                    className="signin-btn"
                  >
                    Parent/Guardian Sign-up
                  </button>
                  
                  <div className="signup-section">
                    <div className="signup-text">Already have an account?</div>
                    <div className="signup-links">
                      <span
                        onClick={() => this.handleRoleSelect("student")}
                        className="signup-link"
                      >
                        Sign-In
                      </span>
                    </div>
                  </div>
                </div>
              </div>
            </Col>

            {/* Student Section */}
            <Col xs={12} md={6} lg={5} className="signup-col" style={{ display: "flex", justifyContent: "center" }}>
              <div className="content-card">
                <div className="login-illustration">
                  <div className="login-img student-img"></div>
                </div>
                
                <div className="button-section">
                  <button
                    onClick={() => this.handleSignUp("student")}
                    className="signin-btn"
                  >
                    Student Sign-up
                  </button>
                  
                  <div className="signup-section">
                    <div className="signup-text">Already have an account?</div>
                    <div className="signup-links">
                      <span
                        onClick={() => this.handleRoleSelect("student")}
                        className="signup-link"
                      >
                        Sign-In
                      </span>
                    </div>
                  </div>
                </div>
              </div>
            </Col>
          </Row>
        </Container>

        {/* Email Modal */}
        <Modal
          show={this.state.openDialog}
          onHide={this.handleCloseDialog}
          centered
          className="email-modal"
        >
          <Modal.Header closeButton>
            <Modal.Title>Enter your email</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <Form>
              <Form.Group controlId="formBasicEmail">
                <Form.Label>Email address</Form.Label>
                <p className="email-info">
                  Only Gmail and Microsoft email IDs are currently accepted.
                </p>
                <Form.Control
                  type="email"
                  placeholder="Enter email"
                  value={this.state.email}
                  onChange={this.handleEmailChange}
                  className="email-input"
                />
                <span className="form-error-message">
                  {this.validator.message(
                    "email",
                    this.state.email,
                    "required|email"
                  )}
                </span>
              </Form.Group>
            </Form>
          </Modal.Body>
          <Modal.Footer>
            <Button 
              variant="secondary" 
              onClick={this.handleCloseDialog}
              className="modal-cancel-btn"
            >
              Cancel
            </Button>
            <Button
              variant="primary"
              onClick={this.handleSubmit}
              className="modal-submit-btn"
              disabled={isLoading}
            >
              {isLoading ? (
                <div className="loading-container">
                  <i className="fas fa-spinner fa-spin"></i>
                </div>
              ) : (
                "Submit"
              )}
            </Button>
          </Modal.Footer>
        </Modal>

         {/* Footer */}
        <div className="footer-section">
          <Footer />
        </div>
      </div>
    );
  }
}

export default withStyles(styles)(ParentStudentLandingPage);